import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import {
  signInWithGoogle,
  signInWithFacebook,
} from "../../../Firebase/authProviders";
import { getProfile } from "../../../redux/profile/action";
import { urtoast } from "../../Layouts/CustomPopup/eventEmitter";

export default function Signuptogetstarted({ }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState("en");


  const handleSocialLogin = async (providerFn) => {
  try {
    setLoading(true);

    const res = await providerFn();
// console.log(res, 'resresresres');

    if (res?.loginRes?.data?.response?.token) {
      const { token, role_type, refresh_token } = res?.loginRes.data.response;

      localStorage.setItem("urexperttoken", token);
      localStorage.setItem("role_type", role_type);
      localStorage.setItem("refresh_token", refresh_token);

      dispatch(getProfile());
      urtoast(res?.loginRes.data.response.message, 1);
      navigate(`/${lan}/account`);
      window.location.reload();
    } else {
      navigate(`/${lan}/signup`, { state: res?.userdetailsforsignup });
      urtoast(res?.loginRes?.data?.response?.message || "Please complete signup", 1);
    }
  } catch (e) {
    urtoast(e?.message || "Social login failed", 2);
  } finally {
    setLoading(false);
  }
};



  return (
    <div className="signup-head">
      <div className="continue-chat">
        <button
          className="btn"
          disabled={loading}
          onClick={() => handleSocialLogin(signInWithGoogle)}
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/google.svg`}
            alt=""
          />
          Continue with Google
        </button>

        <button
          className="btn"
          onClick={() => alert("LinkedIn needs backend OAuth")}
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/linkedin-icon.svg`}
            alt=""
          />
          Continue with LinkedIn
        </button>

        <button
          className="btn"
          disabled={loading}
          onClick={() => handleSocialLogin(signInWithFacebook)}
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/facebook-icon.svg`}
            alt=""
          />
          Continue with Facebook
        </button>
      </div>

      <div className="or">
        <p>OR</p>
      </div>
    </div>
  );
}
